import { TWebsiteBuilderContainer, websiteBuilderNormalizeValidContainer } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderContainer";
import { TWebsiteBuilderElement, websiteBuilderNormalizeValidElement } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { IWebsiteBuilderContent } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderContent";
import { isWebsiteBuilderFooter, IWebsiteBuilderFooter, websiteBuilderGenerateDefaultFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { isWebsiteBuilderHeader, IWebsiteBuilderHeader, websiteBuilderGenerateDefaultHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { websiteBuilderNormalizeSection as websiteBuilderNormalizeValidSection, websiteBuilderSectionValid } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";
import { TWebsiteBuilderNode } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderNode";
import { IWebsiteBuilderSchemaVersionMigrationNode } from "pages/secure/facility/websiteBuilder/editor/schema/migrations/helpers/migrationNode";
import { IWebsiteBuilderGridCell, websiteBuilderNormalizeValidGridCell } from "../../nodes/gridCell/websiteBuilderGridCell";
import { TWebsiteBuilderSectionEntity } from "../../nodes/websiteBuilderSectionEntity";
import { IWebsiteBuilderTab, websiteBuilderNormalizeValidTab } from "../../nodes/tab/websiteBuilderTab";
import { IWebsiteBuilderRoot, websiteBuilderGenerateDefaultRoot, websiteBuilderNormalizeValidRoot, websiteBuilderRootValid } from "../../nodes/root/websiteBuilderRoot";

export type TWebsiteBuilderNormalizeTraverse = typeof normalizeTraverse;

function normalizeTraverse(node: IWebsiteBuilderRoot): IWebsiteBuilderRoot;
function normalizeTraverse(node: IWebsiteBuilderHeader): IWebsiteBuilderHeader;
function normalizeTraverse(node: IWebsiteBuilderContent): IWebsiteBuilderContent;
function normalizeTraverse(node: IWebsiteBuilderFooter): IWebsiteBuilderFooter;
function normalizeTraverse(node: TWebsiteBuilderContainer): TWebsiteBuilderContainer;
function normalizeTraverse(node: IWebsiteBuilderGridCell): IWebsiteBuilderGridCell;
function normalizeTraverse(node: IWebsiteBuilderTab): IWebsiteBuilderTab;
function normalizeTraverse(node: TWebsiteBuilderElement): TWebsiteBuilderElement;
function normalizeTraverse(node: TWebsiteBuilderSectionEntity): TWebsiteBuilderSectionEntity;
function normalizeTraverse(node: TWebsiteBuilderNode): TWebsiteBuilderNode {
  switch (node.type) {
    case "root": return websiteBuilderNormalizeValidRoot(node, normalizeTraverse);
    case "section": return websiteBuilderNormalizeValidSection(node, normalizeTraverse);
    case "container": return websiteBuilderNormalizeValidContainer(node, normalizeTraverse);
    case "grid-cell": return websiteBuilderNormalizeValidGridCell(node, normalizeTraverse);
    case "tab": return websiteBuilderNormalizeValidTab(node, normalizeTraverse);
    case "element": return websiteBuilderNormalizeValidElement(node);
  }
}

export function websiteBuilderNormalizeHeader(migratedHeader: IWebsiteBuilderSchemaVersionMigrationNode): IWebsiteBuilderHeader {
  if (websiteBuilderSectionValid(migratedHeader) && isWebsiteBuilderHeader(migratedHeader)) {
    return normalizeTraverse(migratedHeader);
  } else {
    return websiteBuilderGenerateDefaultHeader();
  }
}

export function websiteBuilderNormalizeRoot(migratedRoot: IWebsiteBuilderSchemaVersionMigrationNode): IWebsiteBuilderRoot {
  if (websiteBuilderRootValid(migratedRoot)) {
    return normalizeTraverse(migratedRoot);
  } else {
    return websiteBuilderGenerateDefaultRoot();
  }
}

export function websiteBuilderNormalizeFooter(migratedFooter: IWebsiteBuilderSchemaVersionMigrationNode): IWebsiteBuilderFooter {
  if (websiteBuilderSectionValid(migratedFooter) && isWebsiteBuilderFooter(migratedFooter)) {
    return normalizeTraverse(migratedFooter);
  } else {
    return websiteBuilderGenerateDefaultFooter();
  }
}